export const HYDRATION_COMPLETE_EVENT = 'ak:hydration-complete';
